import React from 'react'
import { BANKING_BOTTOM_CONTENT, BANKING_COURSE_PAGE_2, BANKING_DETAILS_PAGE_2, BANKING_HERO_PAGE_2 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import { BANKING_ACCORDIAN_2 } from '../../../utils/courseConifg'
import PageDesc from '../../../reusable/PageDesc'


const BankingPage_2 = () => {
  return (
    <div className='outlet-render'>
       <CourseAsideHero {...BANKING_HERO_PAGE_2}/>
      <CoursesAside {...BANKING_COURSE_PAGE_2}/>
      <CourseCard {...BANKING_DETAILS_PAGE_2}/>
      <Accordian{...BANKING_ACCORDIAN_2}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default BankingPage_2